import { Radio } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const DynamicFieldRadio = ({ value, onChange, options, ...props }) => {
  return (<Radio.Group options={options} onChange={onChange} value={value}      {...props}    />
  );
};

DynamicFieldRadio.propTypes = {
  value: PropTypes.any,
  options: PropTypes.array,
  onChange: PropTypes.func,
};

DynamicFieldRadio.defaultProps = {};

export default memo(DynamicFieldRadio);
